import React, { useState } from "react";
import { Header, Sidebar } from "../../components/layout";

interface PageShellProps {
  title: string;
  children?: React.ReactNode;
}

const PageShell: React.FC<PageShellProps> = ({ title, children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="fixed top-0 left-0 right-0 z-50">
        <Header onToggleSidebar={toggleSidebar} />
      </div>

      <div className="flex h-screen pt-16">
        <Sidebar isCollapsed={isSidebarCollapsed} onToggle={toggleSidebar} />

        <main
          className={`flex-1 overflow-auto bg-white transition-all duration-300 ${
            isSidebarCollapsed ? "ml-16" : "ml-72"
          }`}
        >
          <div className="p-8">{children}</div>
        </main>
      </div>
    </div>
  );
};

export default PageShell;
